import { useQuery } from "@tanstack/react-query";
import { fetchCameraMemos } from "~/_legacy/apis/fetch-camera-memos";

export const CAMERA_MEMOS_BY_BRANCH_QUERY_KEY = "cameraMemosByBranch";

export function useGetCameraMemosByBranch({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  return useQuery({
    queryKey: [CAMERA_MEMOS_BY_BRANCH_QUERY_KEY, branchUid, branchVersionId],
    queryFn: () => fetchCameraMemos({ branchUid: branchUid!, branchVersionId }),
    enabled: Boolean(branchUid),
  });
}
